import NavbarSublinks from "pages/PanelPage/components/NavbarSublinks/NavbarSublinks";

export default NavbarSublinks;
